import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Modal } from "app/components/Modal";
import { DropdownIcon } from "app/icons";
import React from "react";

import { useAddSuperModelModal } from "../../hooks/useAddSuperModelModal";
import { useStyles } from "./styles";

const AddSuperModelModal = () => {
  const styles = useStyles();
  const {
    t,
    open,
    form,
    saving,
    fields,
    isValid,
    addTitle,
    onClose,
    setField,
    placeholder,
    fieldLabel,
    optionLabel,
    isNumberField,
    onManufacturerMenuScroll,
    onSubmit,
  } = useAddSuperModelModal();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>{addTitle}</Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t("BUTTONS.CANCEL")}
            disabled={saving}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          {fields.map(({ key, label, type, options = [] }) => (
            <Box key={key} className={styles.field}>
              <Typography className={styles.label}>
                {fieldLabel(label)}
              </Typography>
              <TextField
                className={styles.input}
                fullWidth
                select={type === "select"}
                variant="outlined"
                placeholder={placeholder(label, type)}
                value={form[key]}
                disabled={saving}
                InputProps={{ notched: false }}
                {...(isNumberField(key) && type !== "select"
                  ? { inputMode: "numeric" as const }
                  : {})}
                {...(type === "select"
                  ? {
                      SelectProps: {
                        displayEmpty: true,
                        IconComponent: DropdownIcon,
                        MenuProps: {
                          disableScrollLock: true,
                          PaperProps: {
                            className: styles.selectMenuPaper,
                            onScroll: onManufacturerMenuScroll,
                          },
                          MenuListProps: {
                            className: styles.selectMenuList,
                            onScroll: onManufacturerMenuScroll,
                          },
                        },
                        renderValue: (value) => {
                          const selected = options.find(
                            (option) => option.value === value,
                          );
                          return selected ? (
                            optionLabel(selected)
                          ) : (
                            <span className={styles.placeholder}>
                              {placeholder(label, "select")}
                            </span>
                          );
                        },
                      },
                    }
                  : {})}
                onChange={(event) => setField(key, event.target.value)}
              >
                {type === "select"
                  ? [
                      <MenuItem
                        key="empty"
                        value=""
                        disabled
                        className={styles.selectMenuItem}
                      >
                        {placeholder(label, "select")}
                      </MenuItem>,
                      ...options.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          className={styles.selectMenuItem}
                        >
                          {optionLabel(option)}
                        </MenuItem>
                      )),
                    ]
                  : null}
              </TextField>
            </Box>
          ))}
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={onClose}
            disabled={saving}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!isValid || saving}
            onClick={onSubmit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddSuperModelModal;
